module.exports = __webpack_public_path__ + "img/tips5.7a27a560.png";